module.exports = __webpack_public_path__ + "images/59b70d425b76030836cddd89c844ad55.svg";